import { CardProductAlgolia } from './CardProductAlgolia';

export type { TypeCardProductAlgoliaProps } from './types';
export default CardProductAlgolia;
